import {
  loadObjectFromServer,
  getData,
  putData,
  deleteData,
  postData
} from "@/utils";

export async function logout() {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  const response = await getData(APP_ROUTES.ACCOUNTS_LOGOUT);
  return response;
}

export async function getAccountSettings() {
  try {
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    const response = await getData(APP_ROUTES.ACCOUNTS_SETTINGS);
    return response;
  } catch (e) {
    return null;
  }
}

export async function updateAccountSettings(payload) {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  await putData(APP_ROUTES.ACCOUNTS_SETTINGS, payload);
}

export async function getEmailSenders() {
  try {
    const response = await getData(`/campaigns/email-sender/`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function makeEmailSenderDefault(id, payload) {
  try {
    const response = await putData(`/campaigns/email-sender/${id}/`, payload);
    return response;
  } catch (e) {
    return null;
  }
}

export async function deleteEmailSender(id) {
  try {
    const response = await deleteData(`/campaigns/email-sender/${id}/`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function addEmailSenders(payload) {
  try {
    const response = await postData(`/campaigns/email-sender/`, payload);
    return response;
  } catch (e) {
    return null;
  }
}

export async function getUsers() {
  try {
    const response = await getData(`/accounts/user/`);
    return response;
  } catch (e) {
    return null;
  }
}

export async function addUser(payload) {
  try {
    const response = await postData(`/accounts/user/`, payload);
    return response;
  } catch (e) {
    return null;
  }
}

export async function updateUser(id, payload) {
  try {
    const response = await putData(`/accounts/user/${id}/`, payload);
    return response;
  } catch (e) {
    return null;
  }
}

export async function removeUser(id) {
  const response = await deleteData(`/accounts/user/${id}/`);
  return response;
}

export async function companyFeature() {
  const response = await getData(`/customers/company-features/`);
  return response;
}
export async function companyTokens() {
  const response = await getData(`/accounts/company-tokens/`);
  return response;
}

export async function addCompanyTokens(payload) {
  const response = await postData(`/accounts/company-tokens/`, payload);
  return response;
}
export async function deleteCompanyTokens(id) {
  const response = await deleteData(`/accounts/delete-company-token/${id}/`);
  return response;
}